if (!customElements.get('gift-wrap')) {
  customElements.define(
    'gift-wrap',
    class GiftWrap extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.addButton = this.querySelector('.gift-wrap__add-button');
        this.updateButton = this.querySelector('.gift-wrap__update-button');
        this.editButton = this.querySelector('.gift-wrap__edit-button');
        this.giftMessage = this.querySelector('.gift-wrap__input');
        this.giftCheckbox = this.querySelector('.gift-wrap__checkbox');
        this.cartWrapper = document.querySelector('.cart-wrapper');
        this.nvdWidget = document.querySelector('.nvd-mini');

        this.addButton.addEventListener('click', this.addGiftWrap.bind(this));
        this.giftCheckbox.addEventListener('change', this.onChecked.bind(this));
        this.giftMessage.addEventListener('input', this.onInputMessage.bind(this));
        this.editButton.addEventListener('click', (e) => this.onUpdateMessage(e));
        this.updateButton.addEventListener('click', (e) => this.updateMessage(e, this.updateButton.dataset.giftWrapId, 'Message', this.giftMessage.value));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      connectedCallback() {
        this.giftMessage.innerHTML = localStorage.getItem("text");
      }
      onChecked(evt) {
        if(evt.target.checked && (!this.editButton.classList.contains('active'))) {
          this.giftMessage.classList.add('active');
          this.addButton.classList.add('active');
        } else {
          this.giftMessage.classList.remove('active');
          this.addButton.classList.remove('active');
        }
      }

      onInputMessage(e) {
        this.giftMessage.innerHTML = e.target.value;
      }
      onUpdateMessage(e) {
        e.preventDefault();
        this.editButton.classList.toggle('clicked');
        this.giftMessage.classList.toggle('active');
        this.updateButton.classList.toggle('hidden');
        this.updateButton.classList.toggle('active');
      }
      addGiftWrap(evt) {
        evt.preventDefault();
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        const currentValue = this.giftMessage.innerHTML;
        localStorage.setItem("text", currentValue);
        this.addButton.setAttribute('aria-disabled', true);
        this.addButton.classList.add('loading');
        this.addButton.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
        .then(response => {
          return response.json()
        })
        .then(cart => {
          if(this.cartWrapper) {
            fetch(`${routes.cart_url}?section_id=main-cart-items`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector('#main-cart-items');
              sourceQty.querySelector('.nvd-mini').innerHTML = this.nvdWidget.innerHTML;
              this.cartWrapper.innerHTML = sourceQty.innerHTML;
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.updateButton.classList.remove('loading');
              this.updateButton.querySelector('.loading__spinner').classList.add('hidden');
            })
            this.cart.renderContents(cart);
          }
          else {
            this.cart.renderContents(cart);
          }
          nvd_init();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.addButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.addButton.removeAttribute('aria-disabled');
          this.addButton.querySelector('.loading__spinner').classList.add('hidden');
          document.querySelector('.gift-wrap__input').innerHTML = currentValue;
        });
      }

      updateMessage(e, lineItemId, propertyName, newValue) {
        e.preventDefault();
        this.updateButton.classList.add('loading');
        this.updateButton.querySelector('.loading__spinner').classList.remove('hidden');
        const lineIndex = document.querySelector(`.cart-item-${lineItemId}`).dataset.index;
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        localStorage.setItem("text", newValue);
        const formData = new FormData();
        formData.append('line', parseInt(lineIndex));
        formData.append('properties[' + propertyName + ']', newValue);


        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;
        fetch(`${routes.cart_change_url}`, config)
          .then(response => {
            nvd_init();
            return response.json()
          })
          .then(cart => {
            if(this.cartWrapper) {
              fetch(`${routes.cart_url}?section_id=main-cart-items`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const sourceQty = html.querySelector('#main-cart-items');
                sourceQty.querySelector('.nvd-mini').innerHTML = this.nvdWidget.innerHTML;
                this.cartWrapper.innerHTML = sourceQty.innerHTML;
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.updateButton.classList.remove('loading');
                this.updateButton.querySelector('.loading__spinner').classList.add('hidden');
              })
            }
            else {
              this.cart.renderContents(cart);
            }
            nvd_init();
          })
          .catch(error => {
            console.error('Error updating cart:', error);
          })
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: 'main-cart-items',
            selector: '.cart-wrapper',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'cart-live-region-text',
            section: 'cart-live-region-text',
            selector: '.shopify-section',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          // {
          //   id: 'main-cart-footer',
          //   section: document.getElementById('main-cart-footer').dataset.id,
          //   selector: '.js-contents',
          // },
        ];
      }
    }
  )
}
